import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Notice } from '../components/Notice';
import { desktop, isDesktop } from './bridge';

/**
 * Signale, dans l'application de bureau, qu'un rapport n'est pas sur le
 * disque de ce poste.
 *
 * Le cadre afficherait sinon un message brut renvoyé par le gestionnaire de
 * protocole, sans dire quoi faire. Les fichiers ne descendent que pour les
 * postes suivis — c'est le choix du lot : les données du parc descendent en
 * totalité, les rapports sur demande.
 *
 * Rend `null` dans le navigateur, où le rapport vient toujours du serveur.
 */
export function LocalReportNotice({
  diagnosticId,
  workstationId,
}: {
  diagnosticId: string;
  workstationId: string;
}) {
  const [present, setPresent] = useState<boolean | null>(null);

  useEffect(() => {
    if (!isDesktop()) return;
    let active = true;
    desktop()
      .reports.hasFile(diagnosticId)
      .then((has) => {
        if (active) setPresent(has);
      })
      .catch(() => {
        if (active) setPresent(null);
      });
    return () => {
      active = false;
    };
  }, [diagnosticId]);

  if (!isDesktop() || present !== false) return null;

  return (
    <Notice tone="alerte" title="Rapport absent de ce poste">
      Le fichier n'a pas été téléchargé sur cette machine. Utilisez « Emporter les
      rapports » sur{' '}
      <Link to={`/postes/${workstationId}`}>la fiche du poste</Link> pour le descendre,
      puis attendez la prochaine synchronisation.
    </Notice>
  );
}
